import React from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import PropTypes from 'prop-types'

import { fetchGroupTrackerIfNeeded } from '../../actions'
import Profile from '../../classes/profile'
import Spinner from '../../components/Spinner'
import { LS_HOMEPAGE_KEY } from '../../constants/local_storage'

class GroupTrackerContainer extends React.Component {
  static propTypes = {
    profile: Profile.PropTypes,
    tracker: PropTypes.object,
    fetchGroupTracker: PropTypes.func.isRequired
  }

  componentDidMount () {
    const homepage = JSON.parse(localStorage.getItem(LS_HOMEPAGE_KEY))
    if (homepage) {
      const trackerId = homepage.details.trackers.filter(e => e.is_default)
      const trackerEntityId = trackerId.length > 0 && trackerId[0].tracker_id
      if (trackerEntityId) {
        this.setState({redirectTo: `/insights/tracker/${trackerEntityId}`})
      }
      else {
        this.setState({redirectTo: '/insights/library'})
      }
    } else {
      if (this.props.profile && this.props.profile.groups.length > 0) {
        const groups = this.props.profile.groups
        const groupName = groups.filter(group => group !== 'Admin')[0]
        this.props.fetchGroupTracker(groupName)
      }
    }
  }

  componentDidUpdate (prevProps) {
    if (prevProps.tracker !== this.props.tracker) {
      if (!this.props.tracker.isFetching) {
        if (this.props.tracker.details && this.props.tracker.details.trackers && this.props.tracker.details.trackers.length > 0) {
          const tracker = this.props.tracker.details.trackers.filter(t => t.is_default)
          const trackerId = tracker.length > 0 && tracker[0].tracker_id
          if (trackerId) {
            this.setState({redirectTo: `/insights/tracker/${trackerId}`})
          }
        } else {
          this.setState({redirectTo: '/insights/library'})
        }
      }
    }
  }

  render () {
    if (this.state && this.state.redirectTo) {
      return (<Redirect to={this.state.redirectTo} />)
    } else {
      return (<Spinner />)
    }
  }
}

const mapStateToProps = () => {
  return (state) => {
    const profile = state.user.profile && new Profile(state.user.profile)
    const tracker = state.tracker.list
    return {
      profile,
      tracker
    }
  }
}

function mapDispatchToProps () {
  return (dispatch) => {
    return {
      fetchGroupTracker: (groupName) => dispatch(fetchGroupTrackerIfNeeded(groupName))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupTrackerContainer)
